import React from "react";
import { FiCheckCircle } from "react-icons/fi";
import { credentials } from "./data";

function CredentialBadges() {
  return (
    <section className="ops-section" id="credentials">
      <div className="section-heading">
        <p>Credentials</p>
        <h2>Access badges and learning milestones</h2>
      </div>
      <div className="credential-grid">
        {credentials.map((credential, index) => (
          <article className="credential-card" key={credential}>
            <div className="badge-chip">LVL-{String(index + 1).padStart(2, "0")}</div>
            <FiCheckCircle />
            <h3>{credential}</h3>
            <p>Verified learning path // clearance card active</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default CredentialBadges;
